<template>
  <PopoverText
    :value="formattedValue"
    :label="label"
    :customClass="customClass"
    :tooltipText="tooltipText"
    :dataCy="dataCy"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PopoverText from '@/components/devicePopover/content/popoverText.vue'

export default defineComponent({
  name: 'popoverNumber',
  components: {
    PopoverText
  },
  props: {
    value: Number,
    label: String,
    invalidText: String,
    customClass: String,
    tooltipText: String,
    dataCy: String,
    precision: Number
  },
  computed: {
    formattedValue(): string {
      const noTS = this.invalidText || this.$t('map.popover.valueBlank')
      if (typeof this.value !== 'number') {
        return noTS
      }
      return this.precision ? `${this.value.toFixed(this.precision)}` : `${this.value}`
    }
  }
})
</script>
